import { PayloadAction } from "@reduxjs/toolkit";
import { DashboardData, DashboardFilter, OnboardingData } from "../types/dashboard";

export type DashboardBaseState = {
  data: DashboardData | null;
  filters: DashboardFilter;
  loading: boolean;
  error: string | null;
  expandedDREItems: string[];
  onboarding: OnboardingData;
};

export const criarEstadoBaseDeDashboard = (): DashboardBaseState => ({
  data: null,
  filters: {},
  loading: false,
  error: null,
  expandedDREItems: [],
  onboarding: {
    hasSeenOnboarding: false,
    numFiliais: 1,
    filiaisNames: ["", "", ""],
  },
});

export const dashboardBaseReducers = {
  setDashboardData: (state: DashboardBaseState, action: PayloadAction<DashboardData>) => {
    state.data = action.payload;
    state.loading = false;
    state.error = null;
  },
  setFilters: (state: DashboardBaseState, action: PayloadAction<DashboardFilter>) => {
    state.filters = action.payload;
  },
  setLoading: (state: DashboardBaseState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: DashboardBaseState, action: PayloadAction<string | null>) => {
    state.error = action.payload;
    state.loading = false;
  },
  toggleDREItem: (state: DashboardBaseState, action: PayloadAction<string>) => {
    const itemId = action.payload;
    const index = state.expandedDREItems.indexOf(itemId);
    if (index > -1) {
      state.expandedDREItems.splice(index, 1);
    } else {
      state.expandedDREItems.push(itemId);
    }
  },
  setOnboardingData: (state: DashboardBaseState, action: PayloadAction<Partial<OnboardingData>>) => {
    state.onboarding = { ...state.onboarding, ...action.payload };
  },
  completeOnboarding: (state: DashboardBaseState) => {
    state.onboarding.hasSeenOnboarding = true;
  },
  clearFilters: (state: DashboardBaseState) => {
    state.filters = {};
  },
};
